<template>
    <div class="input__radio">
        <input
            :id="`${_uid}-radio`"
            class="input__radio-item"
            type="radio"
            :value="option"
            v-model="val">
        <label class="input__radio-label"
               :for="`${_uid}-radio`"
               v-html="label"/>
    </div>
</template>

<script>
export default {
    name: 'RadioField',
    props: {
        label: {
            required: true,
            type: String,
        },
        option: {
            type: String,
            required: true,
        },
        value: {
            required: true,
        },
    },
    data: function() {
        return {
            val: null,
        };
    },
    watch: {
        val(value) {
            this.$emit('input', value);
        },
        value: {
            immediate: true,
            handler(value) {
                this.val = value;
            },
        },
    },
};
</script>
